<form #form="ngForm" class="form form-full-width post-scramble-form">
    <div class="table-container">
        <table>
            <thead>
                <tr>
                    <th>Post a Round</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <p class="scramble-help">
                            One gross score for the pair. Field partners both get the net on the leaderboard. A guest only affects the team handicap and does not get credit.
                        </p>
                        <div class="field">
                            <select
                                name="playerId"
                                required
                                [(ngModel)]="playerId"
                                (ngModelChange)="onPlayerChange($event)"
                                #playerModel="ngModel"
                            >
                                <option [ngValue]="null">Select a player</option>
                                <option *ngFor="let p of paidPlayers" [ngValue]="p.playerId">
                                    {{ p.firstName }} {{ p.lastName }}
                                </option>
                            </select>
                            <label>Player</label>
                            <span class="error" *ngIf="playerModel.invalid && playerModel.touched">
                                Pick a player
                            </span>
                        </div>

                        <div class="partner-type">
                            <div class="partner-type-label">Who is the partner?</div>
                            <div class="partner-toggle" role="tablist" aria-label="Partner type">
                                <button
                                    type="button"
                                    role="tab"
                                    [attr.aria-selected]="!partnerIsGuest"
                                    [class.selected]="!partnerIsGuest"
                                    (click)="setPartnerIsGuest(false)">
                                    Field Partner
                                </button>
                                <button
                                    type="button"
                                    role="tab"
                                    [attr.aria-selected]="partnerIsGuest"
                                    [class.selected]="partnerIsGuest"
                                    (click)="setPartnerIsGuest(true)">
                                    Guest Partner
                                </button>
                            </div>
                        </div>

                        <div class="field" *ngIf="!partnerIsGuest">
                            <select
                                name="partnerPlayerId"
                                required
                                [(ngModel)]="partnerPlayerId"
                                (ngModelChange)="onPartnerChange($event)"
                                #partnerModel="ngModel"
                            >
                                <option [ngValue]="null">Select a partner</option>
                                <option *ngFor="let p of partnerOptions" [ngValue]="p.playerId">
                                    {{ p.firstName }} {{ p.lastName }}
                                </option>
                            </select>
                            <label>Partner</label>
                            <span class="error" *ngIf="partnerModel.invalid && partnerModel.touched">
                                Pick a partner
                            </span>
                        </div>

                        <ng-container *ngIf="partnerIsGuest">
                            <div class="field">
                                <input
                                    type="text"
                                    name="guestPartnerName"
                                    required
                                    [(ngModel)]="guestPartnerName"
                                    #guestNameModel="ngModel"
                                    placeholder=" "
                                    maxlength="80"
                                />
                                <label>Guest Name</label>
                                <span class="error" *ngIf="guestNameModel.invalid && guestNameModel.touched">
                                    Guest name is required
                                </span>
                            </div>
                            <div class="field" *ngIf="useHandicaps">
                                <input
                                    type="text"
                                    name="guestPartnerHandicapIndex"
                                    required
                                    [(ngModel)]="guestPartnerHandicapIndex"
                                    #guestHdcpModel="ngModel"
                                    placeholder=" "
                                    inputmode="decimal"
                                />
                                <label>Guest Handicap Index</label>
                                <span class="error" *ngIf="guestHdcpModel.invalid && guestHdcpModel.touched">
                                    Guest handicap is required
                                </span>
                            </div>
                        </ng-container>

                        <div class="field">
                            <input
                                type="text"
                                name="grossScore"
                                required
                                [(ngModel)]="grossScore"
                                #grossScoreModel="ngModel"
                                placeholder=" "
                            />
                            <label>Gross Score</label>
                            <span class="error" *ngIf="grossScoreModel.invalid && grossScoreModel.touched">
                                Score is required
                            </span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <button type="button" (click)="postScore(form)" [disabled]="form.invalid">Post</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</form>

<div class="modal-overlay" *ngIf="warningMessage" (click)="dismissWarning()">
  <div class="modal-sheet warning-sheet" (click)="$event.stopPropagation()">
    <div class="warning-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="48" height="48">
        <path
          d="M12 2.5L1.8 20.5h20.4L12 2.5z"
          fill="#f59e0b"
          stroke="#fbbf24"
          stroke-width="1.2"
          stroke-linejoin="round"
        />
        <rect x="11" y="9" width="2" height="6" rx="1" fill="#111827"/>
        <circle cx="12" cy="17.2" r="1.15" fill="#111827"/>
      </svg>
    </div>
    <div class="modal-title">Heads up</div>
    <p class="warning-message">{{ warningMessage }}</p>
    <button type="button" (click)="dismissWarning()">OK</button>
  </div>
</div>
